// Utils
import { getBasicAuthToken } from "../BasicAuthTokenGetter";
import { getReferringCompany } from "../ReferringCompanyValueGetter/ReferringCompanyValueGetter";
// Constants
import { ORG_CODE_MAPPING_FOR_LOCATION_LOOKUP, ORGANIZATION__CODE_MAPPING } from "../Constants/Constants";

export const getAxiosDetails = () => {
    const referringCompany = getReferringCompany();
    let BASIC_AUTH_TOKEN: string = getBasicAuthToken(referringCompany);
    const Organization: string = ORGANIZATION__CODE_MAPPING[referringCompany];
    const organizationCode: string = ORG_CODE_MAPPING_FOR_LOCATION_LOOKUP[Organization];

    return {
        'baseUrl': '',
        'headers': {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Basic ${BASIC_AUTH_TOKEN}`,
            'Content-Type': 'application/json',
            'X-Organization': organizationCode
        }
    }
}